import { createDecorator, ProcessHandler } from './middleware';

interface SkipIfOptions<T> {
  /**
   * 条件判断函数，返回 true 时跳过方法执行
   */
  when: (this: T, ...args: any[]) => boolean;
  /**
   * 跳过时的回调函数，可用于打印日志
   */
  onSkip?: (this: T, fnName: string, ...args: any[]) => void;
}

/**
 * 装饰器：当条件满足时跳过方法执行
 *
 * @example
 * ```typescript
 * class Connection {
 *   private _isClosed = false;
 *
 *   @skipIf<Connection>({
 *     when() { return this._isClosed; },
 *     onSkip(fnName) { this._log.info(`${fnName} skipped: connection is closed`); }
 *   })
 *   async doPublishChange() {
 *     // ...
 *   }
 * }
 * ```
 */
export function skipIf<T>(options: SkipIfOptions<T>) {
  const { when, onSkip } = options;
  return createDecorator((next: ProcessHandler<T>, fnName: string) => async function (this: T, ...args: any[]) {
    if (when.apply(this, args)) {
      onSkip?.call(this, fnName, ...args);
      return;
    }
    return next.apply(this, args);
  });
}
